import { render, staticRenderFns } from "./PriceScheduling.vue?vue&type=template&id=5323dc05"
import script from "./PriceScheduling.vue?vue&type=script&lang=ts"
export * from "./PriceScheduling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports